import React from "react"

// Colour-coded connection state. Mirrors the admin _connection_badge.html.erb
// colour map. `status` is the enum key (connected / pending / invalid_credentials)
// or "none" when there's no connection.
const CLASSES = {
  connected: "bg-green-50 dark:bg-green-950/40 text-green-700 dark:text-green-300",
  pending: "bg-amber-50 dark:bg-amber-950/40 text-amber-700 dark:text-amber-300",
  invalid_credentials: "bg-red-50 dark:bg-red-950/40 text-red-700 dark:text-red-300",
  invalid_access: "bg-red-50 dark:bg-red-950/40 text-red-700 dark:text-red-300",
  none: "bg-gray-100 dark:bg-gray-800 text-gray-500 dark:text-gray-400",
}

export function ConnectionStatusBadge({ status, label }) {
  const cls = CLASSES[status] || CLASSES.none
  return (
    <span className={`inline-flex rounded-full px-2 py-0.5 text-xs font-medium ${cls}`}>
      {label}
    </span>
  )
}
